import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['table', 'nav', 'navButtons']

  connect() {
    console.log("hscroll_controller.js: connect");
    this.navTarget.addEventListener("scroll", this.scrollHandler);
    const hscroll = this.navTarget
    // Select the table element inside the hscroll element
    const table = this.tableTarget;

    // Get the height of the table element
    const tableHeight = table.getBoundingClientRect().height;

    // Get the height of the window
    const windowHeight = window.innerHeight;

    // Compare the heights and set height:auto on hscroll if the table is smaller than the window
    if (tableHeight < windowHeight) {
      hscroll.style.height = 'auto';
    }
    if(this.navTarget.clientWidth < this.tableTarget.clientWidth) {
      this.navButtonsTarget.classList.remove('hidden')
    }
  }

  disconnect() {
    this.navTarget.removeEventListener("scroll", this.scrollHandler);
  }

  scrollHandler = (event) => {
    console.log('hscroll_controller.js: scrollHandler');
    let tableContainer = event.target;
    let scrollLeft = tableContainer.scrollLeft;
    let firstColumnTDs = tableContainer.querySelectorAll("tr td:first-child");
    let firstColumnTHs = tableContainer.querySelectorAll("tr th:first-child");
    if (scrollLeft > 0) {
      firstColumnTDs.forEach((td) => {
        td.style.boxShadow = "inset -1px 0px 0 #e2e8f0";
      });
      firstColumnTHs.forEach((th) => {
        th.style.boxShadow = "inset -1px 0px 0 #e2e8f0";
      })
    } else {
      firstColumnTDs.forEach((td) => {
        td.style.boxShadow = "none";
      });
      firstColumnTHs.forEach((th) => {
        th.style.boxShadow = "none";
      });
    }
  }

  scrollLeft = (event) => {
    this.navTarget.scrollTo({
      left: this.navTarget.scrollLeft - 200, // Adjust this to change the distance
      behavior: 'smooth'
    });
  }

  scrollRight = (event) => {
    this.navTarget.scrollTo({
      left: this.navTarget.scrollLeft + 200, // Adjust this to change the distance
      behavior: 'smooth'
    });
  }
}
